import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Send } from "lucide-react";
import { Input } from "@/components/ui/input";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const MailingListSection = () => {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setSubmitting(true);
    try {
      const res = await axios.post(`${API}/subscribe`, { email });
      toast.success(res.data.message);
      setEmail("");
    } catch (err) {
      const status = err.response?.status;
      if (status === 429) toast.error("Too many attempts. Please try again later.");
      else if (status === 422) toast.error("Please enter a valid email address.");
      else toast.error("Failed to subscribe. Try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section data-testid="mailing-list-section" className="py-24 md:py-32 tracing-border">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-2xl mx-auto text-center">
          <p className="font-sub text-[10px] text-white/30 tracking-[0.3em] mb-4">STAY CONNECTED</p>
          <h2 className="font-heading text-3xl sm:text-4xl tracking-tighter mb-4">JOIN THE LIST</h2>
          <div className="gold-line mx-auto mb-8" />
          <p className="font-body text-white/40 text-sm mb-10 max-w-md mx-auto">
            Get early access to new releases, exclusive mixes, and event announcements.
            No spam. Unsubscribe anytime.
          </p>

          <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
            <Input
              data-testid="mailing-list-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="flex-1 bg-transparent border border-white/15 rounded-none px-4 py-4 text-white placeholder:text-white/20 focus-visible:ring-0 focus-visible:border-white/40 text-sm"
              placeholder="your@email.com"
              required
            />
            <button
              data-testid="mailing-list-submit"
              type="submit"
              disabled={submitting}
              className="btn-alchemist border border-white/25 bg-white/5 hover:bg-white hover:text-black py-4 px-8 uppercase tracking-widest text-[10px] font-sub transition-colors duration-300 disabled:opacity-30 flex items-center justify-center gap-2 shrink-0"
            >
              <Send className="w-3 h-3" />
              {submitting ? "..." : "Subscribe"}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};
